export const CHAT_DESK_CONFIG = {
  token: '5c5f4021-af51-43f8-b9e6-45907f43f603',
  host: 'https://airtrade.freshchat.com',
  widgetUuid: '21141235-63a4-4753-913c-7597cee5c798'
};
